import { render, staticRenderFns } from "./vippackages_renew.vue?vue&type=template&id=58f8ae52&scoped=true&"
import script from "./vippackages_renew.vue?vue&type=script&lang=js&"
export * from "./vippackages_renew.vue?vue&type=script&lang=js&"
import style0 from "./vippackages_renew.vue?vue&type=style&index=0&id=58f8ae52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f8ae52",
  null
  
)

export default component.exports